export default {
  EASY   : 'EASY',
  MEDIUM : 'MEDIUM',
  HARD   : 'HARD'
};
